import * as React from 'react'
import { FastField } from 'formik'

import { MuiDatePickerFormik } from '@user/components/Formik'
import { SoldServiceAppDataDate } from '@user/store/opportunity'

import { useGetCustomFieldProps } from '../hooks'

type Props = {
  disabled: boolean
  appData: SoldServiceAppDataDate
}

export function DateField(props: Props) {
  const { appData, disabled } = props

  const fieldProps = useGetCustomFieldProps(appData)

  return (
    <FastField
      {...fieldProps}
      variant="inline"
      disablePast={false}
      disabled={disabled}
      inputVariant="outlined"
      component={MuiDatePickerFormik}
      clearable
    />
  )
}
DateField.displayName = 'DateField'
